import { render, staticRenderFns } from "./workDetail.vue?vue&type=template&id=0382f4e6&scoped=true&"
import script from "./workDetail.vue?vue&type=script&lang=js&"
export * from "./workDetail.vue?vue&type=script&lang=js&"
import style0 from "./workDetail.vue?vue&type=style&index=0&id=0382f4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0382f4e6",
  null
  
)

export default component.exports